import { useState } from 'react'
import DateReservation from './DateReservation'
import EditDateReservationModal from 'pages/Modals/EditDateReservationModal'

import {
  Container,
  SubTitle,
  InfoText,
  LabelRow
} from './styles'

export default function DateReservationList ({
  reservations = [],
  onEdit: handleEdit,
  onDelete: handleDelete
}) {
  const [reservationData, setReservationData] = useState (null)
  const [showEditReservationModal, setShowEditReservationModal] = useState (false)

  const editReservation = reservation => {
    setReservationData (reservation)
    toggleEditReservationModal ()
  }

  const toggleEditReservationModal = () => setShowEditReservationModal (!showEditReservationModal) 

  if (reservations.length === 0) return (
    <Container>
      <InfoText>Nenhuma reserva de agenda encontrada</InfoText>
    </Container>
  )

  return (
    <Container>
      <LabelRow>
        <SubTitle>Descrição</SubTitle>
        <SubTitle>Data inicial</SubTitle>
        <SubTitle>Data final</SubTitle>
        <SubTitle>Período</SubTitle>
        <SubTitle>Ações</SubTitle>
      </LabelRow>
      {reservations.map (reservation => (
        <DateReservation
          key={reservation.id}
          data={reservation}
          onEdit={editReservation}
          onDelete={handleDelete}
        />
      ))}
      {!!reservationData && (
        <EditDateReservationModal
          visible={showEditReservationModal}
          data={reservationData}
          onConfirm={handleEdit}
          onClose={toggleEditReservationModal}
        />
      )}
    </Container>
  )
}
